var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('app-bar'),_c('v-main',[_c('v-container',{staticClass:"py-xs-2 px-xs-6 py-md-4 px-md-4",attrs:{"fluid":"","fill-height":""}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }